import Cookies from 'universal-cookie';
const cookies = new Cookies();

const setCookie = (key, value, minutes) => {
    const expireOn = new Date(Date.now() + minutes * 60 * 1000);
    cookies.set(key, value, { path: '/', expires: expireOn });
};

const removeCookie = (name) => {
    cookies.set(name, '', { path: '/', expires: new Date(Date.now()) });
};

const getCookie = (key) => {
    const cookieValue = cookies.get(key);
    return cookieValue;
};

const getAllCookies = () => {
    return cookies.getAll();
};

export { setCookie, getCookie, removeCookie, getAllCookies };